import * as React from 'react'
import { Container } from '../styles'
import { Flex } from 'grid-styled'
import Img from 'gatsby-image'
import { Customer, Content, AfterContent } from './styles'

interface IProps {
  image: object
}

export const AdCases: React.SFC<IProps> = ({ image }) => (
  <Container id="ads">
    <Flex mt={5} justifyContent="center">
      <h1>Google Ads (PPC) Success Stories</h1>
    </Flex>
    <Customer>
      <Content color="#1947a7">
        <a href="https://brisbanewhalewatching.com.au">
          <svg
            version="1"
            xmlns="http://www.w3.org/2000/svg"
            width="834"
            height="1000"
            viewBox="0 0 834 1000"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#FFF"
              d="M112 972l71-241c14-46 24-93 39-139 21-64 5-118-37-169-36-45-72-91-104-139-39-61-55-128-27-198 8-22 28-40 49-58-21 77 33 114 74 154 40 38 85 70 129 103 34 25 59 53 57 100 47-14 95-6 141 5 47 11 94 22 142 25 58 4 108-13 163-27-27 58-55 117-118 150-72 38-150 48-230 45-51-2-64 8-51 57 19 71 46 139 71 208 7 23 17 44 25 62-135-9-278 28-394 62z"
            />
          </svg>
        </a>
        <p>
          Brisbane Whale Watching came to us because the market was getting
          increasingly competitive. Their long established brand was being
          pushed out of sight. We turned to AdWords and helped them reclaim
          literally hudreds of thousands of dollars back from the competition.
        </p>
      </Content>
      <Img fluid={image} />
    </Customer>
  </Container>
)
